import React from "react"
import {Link} from "react-router-dom";

class SignIn extends React.Component {

    render() {
        return (
            <div className='container'>
                <h1 className='page-title'>Přihlášení</h1>
                <div className='row'>
                    <div className='col-lg-4 offset-lg-2'>
                        <div className='card auth-card'>
                            <div className='card-body'>
                                <Link to='/lecturers/sign-in' className='btn btn-primary btn-block'>Přihlásit se jako učitel</Link>
                            </div>
                        </div>
                    </div>
                    <div className='col-lg-4 col-lg-offset-2'>
                        <div className='card auth-card'>
                            <div className='card-body'>
                                <Link to='/students/sign-in' className='btn btn-primary btn-block'>Přihlásit se jako tým</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default SignIn;
